import React from "react";
import { motion } from "framer-motion";
import BECOMEPARTNERONE from "../../assets/Graphics/BecomePartnerOne.png";
import InsightsIcon from "@mui/icons-material/Insights";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import "./styles.css";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";

const BENEFIT_LIST = [
  {
    icon: <TrendingUpIcon fontSize="large" color="primary" />,
    title: "Broaden Your Reach and Grow Revenue",
    description:
      "Gain access to a holistic assurance ecosystem and offer tailored products to your high-intent customer base.",
  },
  {
    icon: <VisibilityIcon fontSize="large" color="primary" />,
    title: "Strengthen Your Brand with Trust",
    description:
      "Leverage our reputation as a preferred partner for global insurers, OEMs, telecoms, and BFSI players.",
  },
  {
    icon: <IntegrationInstructionsIcon fontSize="large" color="primary" />,
    title: "Seamless Tech Integration & Support",
    description:
      "From onboarding to claim fulfilment, our state of the art technology solutions ensure zero operational hassle for you.",
  },
  {
    icon: <InsightsIcon fontSize="large" color="primary" />,
    title: "Real-Time Data & Insights",
    description:
      "Monitor user behaviour, claims, and engagement with live dashboards and analytics to fine-tune your offerings.",
  },
];

const WhyPartnerWithAcross = () => {
  return (
    <div className="py-10 mb-2 bg-[#fff6f1] flex justify-center ">
      <div className="w-full max-w-screen-xl flex flex-col">
        <div className="text-center mb-4">
          {/* <Heading title="Why Partner with Across Assist?" /> */}
          <h4 className="text-xl md:text-[2.5rem]  font-poppins">
            Why Partner with Across Assist?  
          </h4>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center w-full md:p-4">
          {/* Left: Benefits List */}
          <div className="w-full md:w-7/12 ">
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <div className="px-2 md:px-4">
                {BENEFIT_LIST.map((benefit, index) => (
                  <div key={index} className="mb-6">
                    <div className="flex items-start">
                      <div className="mr-4 mt-[-0.5rem] flex-shrink-0 mt-2">
                        {benefit.icon}
                      </div>
                      <div>
                        <h6
                          className="text-base md:text-lg font-semibold font-poppins "
                          style={{ fontFamily: '"Poppins", serif' }}
                        >
                          {benefit.title}
                        </h6>
                        <p
                          className="text-justify text-sm md:text-base font-poppins mt-2"
                          style={{ fontFamily: '"Poppins", serif' }}
                        >
                          {benefit.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
          {/* Right: Image */}
          <div className="w-full md:w-5/12 flex justify-end  mt-8 md:mt-0">
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 1 }}
              className="flex justify-end w-full"
            >
              <img
                src={BECOMEPARTNERONE}
                alt="Career Puzzle"
                className="w-full sm:w-4/5 md:w-3/4 max-h-[400px] object-contain ml-auto"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyPartnerWithAcross;
